define([
    'text!fnjimedia/component/main.html',
    'common/api',
    'jquery',
    'common/utils',
    'masonry','imagesloaded'


], function(
    tpl,Api,$,Utils,Masonry
){
    return {
        template: tpl,
        data: function(){
            return {
                isPC: true,
                fnjiMedia: []
            };
        },
        components: {
        },
        computed: {

        },
        created: function () {
            var obj = this;


        },
        methods: {
            toColor: function(index,num) {
                var obj = this;
                if(index===1){
                    $('.media2021').eq(num).css({filter: 'grayscale(0%)',transition: 'all 0.3s'});
                }else {
                    $('.media2021').eq(num).css({filter: 'grayscale(100%)',transition: 'all 0.3s'});
                }
            },
            init: function () {
                var obj = this;
                if($(window).width()<=750){
                    obj.isPC = false;
                    $('.fixed-menu').css({display: 'none'});
                }else {
                    obj.isPC = true;
                }
                Api.getAllFnjiMeida.ajax(
                    {

                    }).done(function (data)
                    {
                        obj.fnjiMedia = data.tableData;

                        obj.$nextTick(function(){
                            obj.initMasonry();
                        });
                        Utils.emitPageReady();

                    });
            },
            initMasonry:function () {

                // var jQueryBridget = require('jquery-bridget');
                // var Masonry = require('masonry');
                // require(['jquery', 'masonry'], function($, _){
                // })
                // var Masonry = require('masonry');
                // require('imagesloaded');
                // var tab = require('imports-loader?$=jquery!imagesloaded');
                // var Masonry = require('imports-loader?$=jquery!masonry');
// // var msnry = new Masonry($(".media-list")[0],
//                 //     {
//                 //         itemSelector: 'li',
//                 //         gutter:0,
//                 //         isAnimated: true
//                 //     });
//
//                 // var jQueryBridget = require('jquery-bridget');
//                 // var Masonry = require('masonry-layout');
//                 // jQueryBridget( 'masonry', Masonry, $ );

                imagesLoaded($(".media-list")[0], function( instance ) {
                    var msnry = new Masonry($(".media-list")[0],
                        {
                            itemSelector: 'li',
                            gutter:0,
                            isAnimated: true
                        });
                });
                    //
                    // $(".media-list").imagesLoaded(function(){
                    //
                    //
                    // });

            }

        },
        mounted: function(){
            this.init();
            var obj = this;
            $(window).resize( function  () {           //当浏览器大小变化时
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                }
            });
        },






    };
});


//////////////////
// WEBPACK FOOTER
// ./fnjimedia/component/main.js
// module id = 115
// module chunks = 2